import { GwrGebaeudeListEntry, GwrgebaeudeService } from '../../../core/gwr-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { Location } from '@angular/common';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';
import { GwrStatus } from '../../../shared/enum/GwrStatus';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { GwrGebaeudeTableComponent } from '../gwr-gebaeude-table/gwr-gebaeude-table.component';

@Component({
  selector: 'cap-gwr-gebaeude-search-result',
  templateUrl: './gwr-gebaeude-search-result.component.html',
  styleUrls: ['./gwr-gebaeude-search-result.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    GwrGebaeudeTableComponent,
    TranslatePipe
  ]
})
export class GwrGebaeudeSearchResultComponent extends AbstractComponent implements OnInit, OnDestroy {
  searchMode: SearchMode;

  listLoader: ListLoader<GwrGebaeudeListEntry>;

  constructor(
    private gwrGebaeudeService: GwrgebaeudeService,
    private stateService: SearchStateService,
    protected router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private location: Location
  ) {
    super();
    keysToTranslate<string>(['FehlerBeimAufrufDesWebservice']);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.searchMode = params['searchMode'];
      this.route.queryParams.subscribe((param) => {
        const requestParam = param['request'];
        if (requestParam) {
          const request = JSON.parse(requestParam) || {};
          this.stateService.lastSearchMode = this.searchMode;
          this.loadGwrGebaeude(request);
        }
      });
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.listLoader) {
      this.listLoader.unsubscribeAll();
    }
  }

  private loadGwrGebaeude(request: any) {
    this.addSub(
      this.getGebaeudeListSubscription(request)[this.searchMode].subscribe({
        next: (response) => {
          const wsStatus = response.gwrStatusCode;
          if (wsStatus.statusCode === GwrStatus.NORESULTS) {
            this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, true);
            this.navigateBackToSearch();
          } else if (wsStatus.statusCode !== GwrStatus.OK) {
            const alertText = this.translate.instant('FehlerBeimAufrufDesWebservice');
            this.capAlertService.warning(`${alertText}: ${wsStatus.statusCode} (${wsStatus.text})`, CapAlertLevel.CONTENT_HEADER, true);
            this.navigateBackToSearch();
          } else if (response.results.length === 1) {
            this.router.navigate(['../../detail', response.results[0].egid], { relativeTo: this.route });
          } else {
            this.fillGebaeudeListFrom(response);
          }
        },
        error: (err) => this.handleError(err)
      })
    );
  }

  private handleError(err) {
    throw err;
  }

  navigateBackToSearch() {
    this.location.back();
  }

  private fillGebaeudeListFrom(response) {
    this.listLoader = new ListLoaderPreloaded<GwrGebaeudeListEntry>(15, 1, response.results);
  }

  private getGebaeudeListSubscription(request) {
    return {
      fromGrundstueck: this.gwrGebaeudeService.searchGebaeudeStandard(request),
      searchStandard: this.gwrGebaeudeService.searchGebaeudeStandard(request),
      searchFachId: this.gwrGebaeudeService.searchGebaeudeEgid(request)
    };
  }
}
